import React, { useCallback, useRef, useState } from 'react'
import classNames from 'classnames'

import { IFaqType } from '@/types'

interface IFAQListProps {
  title?: string
  items: IFaqType[]
  className?: string
}

export const FAQList: React.FC<IFAQListProps> = ({
  items,
  title,
  className,
}) => {
  const divRef = useRef<HTMLDivElement>(null)
  const [selected, setSelected] = useState<number | undefined>(0)

  const onSelect = useCallback(
    (item?: number) => () => {
      setSelected(prev => (prev === item ? undefined : item))
      divRef.current?.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      })
    },
    [],
  )

  return (
    <section
      className={classNames(
        'theme--light-blue policies_section padding-vertical-regular',
        className,
      )}
    >
      <div className="row">
        {!!title && (
          <div className="column small-12">
            <h2 className="white-color">{title}</h2>
          </div>
        )}
        <div className="column small-12'">
          <div className="policies_wrapper">
            <div ref={divRef} className="policies_list">
              {items.map((_item, idx) => (
                <div
                  key={_item.id}
                  onClick={onSelect(idx)}
                  className={classNames('policies_list-item', {
                    active: selected === idx,
                  })}
                >
                  <div className="flex-container align-middle align-justify policies_list-item-title">
                    <p>{_item.question}</p>
                    <i className="arrow--right"></i>
                  </div>
                  <div
                    className="policies_list-info"
                    dangerouslySetInnerHTML={{ __html: _item.answer ?? '' }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
